import { ApiService } from 'src/app/shared/services/api.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AnnouncementOverlayService } from './shared/services/announcement-overlay.service';
import { PageDataService } from './shared/services/page-data.service';
import { PageCategoryType } from './shared/models/ApiModels';
import { SchoolDetailsService } from './shared/services/school-details.service';
import { SchoolMapService } from './shared/services/school-map.service';
import { Title } from '@angular/platform-browser';
import { FaviconService } from './shared/services/favicon.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  headerType = '';

  constructor(
    private apiService: ApiService,
    private schoolService: SchoolDetailsService,
    private schoolMapService: SchoolMapService,
    private pageDataService: PageDataService,
    private announcementService: AnnouncementOverlayService,
    private title: Title,
    private favicon: FaviconService
  ) {}

  ngOnInit(): void {

    this.schoolService.loadFromSession();

    this.loadSchool();

    this.pageDataService.pageData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((pages) => {
        if (!pages) return;

        const homePage = pages.find(p => p.name === 'Home');
        if (!homePage?.category?.length) return;

        const announcementCategory = homePage.category.find(
          c => c?.category === PageCategoryType.ANNOUNCEMENT
        );

        if (!announcementCategory?.content?.length) return;

        const announcements = announcementCategory.content
          .filter(c => c?.content);

        if (announcements.length) {
          this.announcementService.setAnnouncements(announcements);
        }
      });

      this.headerType = this.schoolMapService.getHeaderType();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSchool(): void {

    this.schoolService.setLoading();

    const schoolId = this.schoolMapService.getSchoolId();
    const favicon = this.schoolMapService.getFavicon();

    if (favicon) {
      this.favicon.setFavicon(favicon);
    }

    this.apiService.getSchoolDetails(schoolId)
      .subscribe({
        next: (res: any) => {
          if (!res?.data) {
            this.schoolService.setError('School data not found');
            return;
          }

          this.schoolService.setSchool(res.data);
          this.title.setTitle(res.data.schName);

          this.pageDataService.loadPageData();
        },
        error: () => {
          this.schoolService.setError('Failed to fetch school data');
        }
      });
  }
}